// @flow

import createAction            from 'redux-actions/lib/createAction';
import type { LocationRecord } from '../../modules/react-router/domain/react-router.domain';


// -----------------------------------------------------------------------------------------------------------------
// Types
// -----------------------------------------------------------------------------------------------------------------

export type ReplacePathInRouterHistoryActionType = 'ROUTER_HISTORY:REPLACE_PATH';

export type ReplacePathInRouterHistoryActionPayload = {|
  location: LocationRecord,
|};

export type ReplacePathInRouterHistoryActionMeta = {||};

export type ReplacePathInRouterHistoryActionArgs = {|
  location: LocationRecord,
|};

export type ReplacePathInRouterHistoryAction = {
  type: ReplacePathInRouterHistoryActionType,
  payload: ReplacePathInRouterHistoryActionPayload,
  meta: ReplacePathInRouterHistoryActionMeta,
};


// -----------------------------------------------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------------------------------------------

const type: ReplacePathInRouterHistoryActionType = 'ROUTER_HISTORY:REPLACE_PATH';


// -----------------------------------------------------------------------------------------------------------------
// Action
// -----------------------------------------------------------------------------------------------------------------

const replacePathInRouterHistory: (ReplacePathInRouterHistoryActionArgs) => ReplacePathInRouterHistoryAction = createAction(
  type,
  ({location}: ReplacePathInRouterHistoryActionArgs) => ({location}),
);


// -----------------------------------------------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------------------------------------------

export default replacePathInRouterHistory;



// WEBPACK FOOTER //
// ./src/actions/router/replacePathInRouterHistory.js